import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PayrollInputSnapshotSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/payroll-engine/_layout/input-snapshots/')({
  validateSearch: zodValidator(PayrollInputSnapshotSearchSchema)
});